export function isLocalhost(withDev = false) {
    return (window.location.hostname !== 'eksmo.ru' && window.location.hostname !== 'admin.eksmo.ru' && (withDev ? true : window.location.hostname !== 'dev.eksmo.ru'));
}